export const getEstimatedDeliveryDate = variant => {
  const options = {
    orderDeadlineTime: 15,
    latestArrivalPaddingGlobal: 6,
    earliestArrivalPaddingGlobal: 0,
    hideIfUnavailable: true,
    leadtimes: [
      {
        id: '1',
        label: 'Same Day',
        leadtime: 0,
        latestShipPaddingOverride: 5
      },
      {
        id: '46',
        label: '1-2 Days',
        leadtime: 2,
        latestShipPaddingOverride: null
      },
      {
        id: '3',
        label: 'DS 1 week',
        leadtime: 5,
        latestShipPaddingOverride: null
      },
      {
        id: '35',
        label: 'DS 2 weeks',
        leadtime: 10,
        latestShipPaddingOverride: null
      },
      {
        id: '5',
        label: '1 week',
        leadtime: 5,
        latestShipPaddingOverride: null
      },
      {
        id: '7',
        label: '2 weeks',
        leadtime: 10,
        latestShipPaddingOverride: null
      },
      {
        id: '8',
        label: '3 weeks',
        leadtime: 15,
        latestShipPaddingOverride: null
      },
      {
        id: '9',
        label: '6 weeks',
        leadtime: 30,
        latestShipPaddingOverride: null
      },
      {
        id: '25',
        label: '4 weeks',
        leadtime: 20,
        latestShipPaddingOverride: null
      },
      {
        id: '41',
        label: '5 weeks',
        leadtime: 25,
        latestShipPaddingOverride: null
      },
      {
        id: '27',
        label: '6 weeks',
        leadtime: 30,
        latestShipPaddingOverride: null
      },
      {
        id: '39',
        label: '12 weeks',
        leadtime: 60,
        latestShipPaddingOverride: null
      },
      {
        id: '40',
        label: '8 weeks',
        leadtime: 40,
        latestShipPaddingOverride: null
      },
      {
        id: '42',
        label: 'No Ship',
        leadtime: 'no-ship',
        latestShipPaddingOverride: null
      },
      {
        id: '43',
        label: '10 Weeks',
        leadtime: 50,
        latestShipPaddingOverride: null
      },
      {
        id: '43',
        label: '9 Weeks',
        leadtime: 45,
        latestShipPaddingOverride: null
      }
    ],
    ryonetHolidays: JSON.parse(document.getElementById('holidays-observed').textContent).holidays
  };

  if (options.hideIfUnavailable && variant.available !== undefined && !variant.available) return null;

  const leadTime = variant.metafields.leadTime;
  const leadtimeData = getLeadtimeData(options.leadtimes, leadTime);

  if (leadtimeData.id === 'no match') return 'no match';
  if (leadtimeData.id === '42') return 'no-ship';

  const isSameDay = leadtimeData.id === '1';

  // Get today's PST date.
  const startDate = new Date();
  startDate.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
  const startDateSystemString = startDate.toString();

  // Add a day if after cutoff time.
  const isAfterCutoff = startDate.getHours() >= options.orderDeadlineTime;
  if (isAfterCutoff) startDate.setDate(startDate.getDate() + 1);


  if (options.earliestArrivalPaddingGlobal > 0) {
    startDate.setDate(startDate.getDate() + options.earliestArrivalPaddingGlobal);
  }

  const businessDays = addLatePaddingToLeadtime(options, leadtimeData);
  let deliveryDateMessage = null;

  if (isSameDay) {
    const sameDayEarly = isAfterCutoff ? 2 : 1;
    const sameDayEarlyWithBuffer = options.earliestArrivalPaddingGlobal > 0
      ? sameDayEarly + options.earliestArrivalPaddingGlobal
      : sameDayEarly;
    const earlyEstDeliveryDate = calculateDeliveryDate(new Date(startDateSystemString), sameDayEarlyWithBuffer);
    const earlyDateIsTomorrow = dateIsTomorrow(earlyEstDeliveryDate);
    const earlyDayOfMonth = ordinalFormat(earlyEstDeliveryDate.getDate());
    const earlyDayOfWeek = earlyEstDeliveryDate.toLocaleDateString('en-US', { weekday: 'long' });

    const lateEstDeliveryDate = calculateDeliveryDate(startDate, businessDays);
    const lateDayOfMonth = ordinalFormat(lateEstDeliveryDate.getDate());
    const lateDayOfWeek = lateEstDeliveryDate.toLocaleDateString('en-US', { weekday: 'long' });
    const lateMonthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'][(lateEstDeliveryDate.getMonth())];
    const earlyDateText = earlyDateIsTomorrow ? `tomorrow` : `${earlyDayOfWeek}, the ${earlyDayOfMonth}`;
    const lateDateText = `${lateDayOfWeek}, ${lateMonthName} ${lateDayOfMonth}`;
    deliveryDateMessage = `<span><span class="bold"> Ships Same Day </span> Before Cutoff.  <a href="https://www.screenprinting.com/pages/shipping-return-policies">Click to Learn More<a/></span>.`;
  } else {
    const estDeliveryDate = calculateDeliveryDate(startDate, businessDays);
    const dayOfMonth = ordinalFormat(estDeliveryDate.getDate());
    const dayOfWeek = estDeliveryDate.toLocaleDateString('en-US', { weekday: 'long' });
    const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'][(estDeliveryDate.getMonth())];
    const dateText = `${dayOfWeek}, ${monthName} ${dayOfMonth}`;
    deliveryDateMessage = `<span>Est. delivery by: <span class="bold">${dateText}</span></span>`;
  }

  return deliveryDateMessage;

  function calculateDeliveryDate(startDate, businessDays) {
    let loopDate = null;
    let counter = 0;

    while (counter < businessDays) {
      loopDate = new Date(startDate.setDate(startDate.getDate() + 1));
      const isWeekend = loopDate.getDay() === 0 || loopDate.getDay() === 6;
      if (isWeekend) continue;
      const isHoliday = isRyonetHoliday(loopDate, options.ryonetHolidays);
      if (isHoliday) continue;
      counter++;
    }
    return loopDate;
  }

  function isRyonetHoliday(dtDate, holidays) {
    // TODO: All dates are in PST. For customers in PA, can we convert to their timezone?
    const formattedDate = new Date(dtDate.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })).toISOString().split('T')[0];

    const findHolidays = holidays.find(holidayObj => {
      const holidayDate = new Date(holidayObj.date).toISOString().split('T')[0];
      if (holidayObj.incrementsShippingEstimate === false) return false;
      return formattedDate === holidayDate;
    });

    return findHolidays !== undefined;
  }

  function getLeadtimeData(leadtimes, leadTime) {
    for (let leadtimeObj of leadtimes) {
      if (leadtimeObj.label.toLowerCase() === leadTime.toLowerCase()) {
        return leadtimeObj;
      }
    }
    const errorMsg = `No leadtime id match for ${leadTime}`;
    console.warn(errorMsg);
    return { id: 'no match', variantLeadtimeId: leadTime };
  }

  function addLatePaddingToLeadtime(options, leadtimeData) {
    return (leadtimeData.latestShipPaddingOverride
      ? leadtimeData.leadtime + leadtimeData.latestShipPaddingOverride
      : leadtimeData.leadtime + options.latestArrivalPaddingGlobal);
  }

  function ordinalFormat(d) {
    if (d > 3 && d < 21) return d + 'th';
    switch (d % 10) {
      case 1: return d + "st";
      case 2: return d + "nd";
      case 3: return d + "rd";
      default: return d + "th";
    }
  }

  function dateIsTomorrow(date) {
    const compareDate = date.toDateString();
    let tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);
    tomorrow = tomorrow.toDateString();
    return compareDate === tomorrow;
  }
};